export const DEFAULT_LUMIGO_PRODUCTS = [
  {
    _id: "dxax-150t",
    name: "DXAX-150T Outdoor Gobo Projector",
    modelNumber: "DXAX-150T",
    sku: "LMG-DXAX-150T",
    brandName: "LUMIGO",
    category: "Outdoor Gobo Projectors",
    shortDescription: "Heavy-duty IP65 waterproof commercial gobo projector with 150W OSRAM LED optical engine, designed for 3–25 metre outdoor building and pavement logo projection.",
    description: "The DXAX-150T is LUMIGO's flagship commercial outdoor gobo projector engineered for high-visibility architectural facade illumination, building branding, and pavement projection.",
    price: 32500,
    discountPrice: 28500,
    images: [
      "/assets/lumigo/projector-1.jpg",
      "/assets/lumigo/projector-2.jpg",
      "/assets/lumigo/projector-3.jpg",
      "/assets/lumigo/projector-4.jpg",
    ],
    videoUrl: "/assets/lumigo/video-demo-1.mp4",
    isFeatured: true,
    isActive: true,
    specifications: {
      projectionDistance: "3–25 metres",
      power: "150 W",
      voltage: "90–220 V, 50/60 Hz",
      lightSource: "OSRAM LED",
      lightSourceLifetime: "80,000 hours",
      luminousFlux: "15,000 lm",
      ipRating: "IP65 Waterproof",
      colorTemperature: "9500 K",
      weight: "3.5 kg",
    },
  },
  {
    _id: "dxax-80t",
    name: "DXAX-80T Compact Outdoor Gobo Projector",
    modelNumber: "DXAX-80T",
    sku: "LMG-DXAX-80T",
    brandName: "LUMIGO",
    category: "Outdoor Gobo Projectors",
    shortDescription: "Compact 80W weatherproof IP65 projector ideal for boutique storefronts, restaurant entrances, and mid-range 3–15m logo projection.",
    description: "Designed for compact installations requiring high optical clarity, the DXAX-80T delivers radiant projection at an energy-efficient 80W footprint.",
    price: 21500,
    discountPrice: 18900,
    images: [
      "/assets/lumigo/projector-5.jpg",
      "/assets/lumigo/projector-6.jpg",
      "/assets/lumigo/projector-7.jpg",
    ],
    videoUrl: "/assets/lumigo/video-demo-2.mp4",
    isFeatured: true,
    isActive: true,
    specifications: {
      projectionDistance: "3–15 metres",
      power: "80 W",
      voltage: "90–240 V, 50/60 Hz",
      lightSource: "OSRAM LED",
      lightSourceLifetime: "60,000 hours",
      luminousFlux: "8,500 lm",
      ipRating: "IP65",
      colorTemperature: "8500 K",
      weight: "2.8 kg",
    },
  },
  {
    _id: "dxax-200t",
    name: "DXAX-200T High-Power Architectural Projector",
    modelNumber: "DXAX-200T",
    sku: "LMG-DXAX-200T",
    brandName: "LUMIGO",
    category: "Outdoor Gobo Projectors",
    shortDescription: "Ultra-bright 200W commercial projection unit engineered for 5–40m architectural building facades and large-scale industrial branding.",
    description: "The DXAX-200T is a high-output architectural gobo projector built for demanding commercial sites, industrial complexes, and multi-storey facades.",
    price: 45000,
    discountPrice: 39500,
    images: [
      "/assets/lumigo/projector-8.jpg",
      "/assets/lumigo/projector-9.jpg",
      "/assets/lumigo/projector-10.jpg",
    ],
    videoUrl: "/assets/lumigo/video-demo-3.mp4",
    isFeatured: true,
    isActive: true,
    specifications: {
      projectionDistance: "5–40 metres",
      power: "200 W",
      voltage: "100–240 V, 50/60 Hz",
      lightSource: "OSRAM High-Lumen LED",
      lightSourceLifetime: "80,000 hours",
      luminousFlux: "22,000 lm",
      ipRating: "IP65 Waterproof",
      colorTemperature: "9500 K",
      weight: "4.8 kg",
    },
  },
  {
    _id: "dxax-300t",
    name: "DXAX-300T Ultra Long-Range Facade Projector",
    modelNumber: "DXAX-300T",
    sku: "LMG-DXAX-300T",
    brandName: "LUMIGO",
    category: "Architectural & Festive",
    shortDescription: "Extreme-range 300W architectural gobo projector for 10–60m monumental building mapping and city-scale landmark branding.",
    description: "Engineered for monumental applications, the DXAX-300T harnesses a 300W industrial LED module to project razor-sharp corporate insignias.",
    price: 68000,
    discountPrice: 62000,
    images: [
      "/assets/lumigo/projector-11.jpg",
      "/assets/lumigo/projector-12.jpg",
      "/assets/lumigo/projector-13.jpg",
    ],
    videoUrl: "/assets/lumigo/video-demo-1.mp4",
    isFeatured: false,
    isActive: true,
    specifications: {
      projectionDistance: "10–60 metres",
      power: "300 W",
      voltage: "100–260 V, 50/60 Hz",
      lightSource: "Industrial Grade OSRAM LED",
      lightSourceLifetime: "80,000 hours",
      luminousFlux: "32,000 lm",
      ipRating: "IP65",
      colorTemperature: "9000 K",
      weight: "7.2 kg",
    },
  },
  {
    _id: "dxin-50",
    name: "DXIN-50 Commercial Indoor Logo Projector",
    modelNumber: "DXIN-50",
    sku: "LMG-DXIN-50",
    brandName: "LUMIGO",
    category: "Indoor Logo Projectors",
    shortDescription: "Sleek 50W indoor projector for retail stores, corporate lobbies, hotel receptions, and point-of-sale branding across 2–10m.",
    description: "The DXIN-50 is engineered for refined indoor environments where silent operation, elegant form factor, and pristine projection clarity are paramount.",
    price: 14500,
    discountPrice: 12500,
    images: [
      "/assets/lumigo/projector-14.jpg",
      "/assets/lumigo/projector-15.jpg",
    ],
    videoUrl: "/assets/lumigo/video-demo-2.mp4",
    isFeatured: true,
    isActive: true,
    specifications: {
      projectionDistance: "2–10 metres",
      power: "50 W",
      voltage: "100–240 V, 50/60 Hz",
      lightSource: "High-CRI OSRAM LED",
      lightSourceLifetime: "50,000 hours",
      luminousFlux: "5,200 lm",
      ipRating: "IP20",
      colorTemperature: "8000 K",
      weight: "1.9 kg",
    },
  },
  {
    _id: "dxin-100",
    name: "DXIN-100 High-Output Indoor Gobo Projector",
    modelNumber: "DXIN-100",
    sku: "LMG-DXIN-100",
    brandName: "LUMIGO",
    category: "Indoor Logo Projectors",
    shortDescription: "High-intensity 100W indoor projector designed for illuminated shopping mall atriums, banquet halls, and trade expo centers.",
    description: "Designed for brightly lit indoor commercial spaces where standard projectors wash out. The DXIN-100 produces vibrant, crisp logo and pattern projections.",
    price: 19500,
    discountPrice: 16900,
    images: [
      "/assets/lumigo/projector-16.jpg",
      "/assets/lumigo/projector-17.jpg",
    ],
    videoUrl: "/assets/lumigo/video-demo-2.mp4",
    isFeatured: false,
    isActive: true,
    specifications: {
      projectionDistance: "3–18 metres",
      power: "100 W",
      voltage: "100–240 V, 50/60 Hz",
      lightSource: "OSRAM LED",
      lightSourceLifetime: "60,000 hours",
      luminousFlux: "11,000 lm",
      ipRating: "IP20",
      colorTemperature: "8500 K",
      weight: "2.6 kg",
    },
  },
  {
    _id: "dx-rot4",
    name: "DX-ROT4 4-Pattern Carousel Rotating Gobo Projector",
    modelNumber: "DX-ROT4",
    sku: "LMG-DX-ROT4",
    brandName: "LUMIGO",
    category: "Dynamic & Effect Projectors",
    shortDescription: "Dynamic 4-logo carousel projector that automatically cycles through 4 custom gobos with programmable dwell time.",
    description: "The DX-ROT4 features an internal motorized 4-slot gobo carousel wheel. It automatically switches between 4 separate company logos.",
    price: 36000,
    discountPrice: 31900,
    images: [
      "/assets/lumigo/projector-18.jpg",
      "/assets/lumigo/projector-19.jpg",
    ],
    videoUrl: "/assets/lumigo/video-demo-1.mp4",
    isFeatured: true,
    isActive: true,
    specifications: {
      projectionDistance: "3–20 metres",
      power: "120 W",
      voltage: "90–240 V, 50/60 Hz",
      lightSource: "OSRAM LED",
      lightSourceLifetime: "70,000 hours",
      luminousFlux: "12,500 lm",
      ipRating: "IP65 Weatherproof",
      colorTemperature: "9000 K",
      weight: "4.1 kg",
    },
  },
  {
    _id: "dx-water-100",
    name: "DX-WATER 100W Dynamic Water Wave & Ripple Effect Projector",
    modelNumber: "DX-WATER-100",
    sku: "LMG-DX-WATER",
    brandName: "LUMIGO",
    category: "Dynamic & Effect Projectors",
    shortDescription: "Ambient optical wave effect projector producing soothing water ripple and aurora wave dynamics for luxury hospitality.",
    description: "Create mesmerizing dynamic atmospheres with the DX-WATER projector. Dual motorized ripple glass plates create authentic flowing water visuals.",
    price: 26500,
    discountPrice: 22900,
    images: [
      "/assets/lumigo/projector-20.jpg",
      "/assets/lumigo/projector-21.jpg",
    ],
    videoUrl: "/assets/lumigo/video-demo-3.mp4",
    isFeatured: false,
    isActive: true,
    specifications: {
      projectionDistance: "3–25 metres",
      power: "100 W",
      voltage: "90–240 V, 50/60 Hz",
      lightSource: "High-Power RGBW / Cool White LED",
      lightSourceLifetime: "60,000 hours",
      luminousFlux: "9,000 lm",
      ipRating: "IP65 Weatherproof",
      colorTemperature: "Water Blue 6500K",
      weight: "3.6 kg",
    },
  },
  {
    _id: "dx-custom",
    name: "DX-CUSTOM Precision Dichroic Glass Gobo Lens",
    modelNumber: "DX-CUSTOM",
    sku: "LMG-DX-CUSTOM",
    brandName: "LUMIGO",
    category: "Custom Glass Gobos",
    shortDescription: "High-definition custom glass gobo lenses manufactured with ultra-precision laser etching for monochrome and full-color brand logos.",
    description: "LUMIGO manufactures precision heat-resistant borosilicate and dichroic glass gobos compatible with all LUMIGO projector models.",
    price: 3500,
    discountPrice: 2800,
    images: [
      "/assets/lumigo/projector-22.jpg",
      "/assets/lumigo/projector-1.jpg",
    ],
    videoUrl: "",
    isFeatured: true,
    isActive: true,
    specifications: {
      projectionDistance: "Matched to Projector Optics",
      power: "Rated up to 500W Projectors",
      voltage: "Passive Optical Element",
      lightSource: "High-Precision Laser Etched Glass",
      lightSourceLifetime: "Heat Resistant up to 500°C",
      luminousFlux: ">96% Optical Transmission",
      ipRating: "Sealed Inside Projector",
      colorTemperature: "Full Spectrally Neutral",
      weight: "15 grams",
    },
  },
  {
    _id: "dx-rangoli-100",
    name: "DX-RANGOLI Festive, Cultural & Event Decorative Projector",
    modelNumber: "DX-RANGOLI-100",
    sku: "LMG-DX-RANGOLI",
    brandName: "LUMIGO",
    category: "Architectural & Festive",
    shortDescription: "Dynamic rotating cultural rangoli and festive decorative gobo projector for Diwali, weddings, and hotel celebrations.",
    description: "Bring traditional Indian art to life with radiant, clean illuminated projections. The DX-RANGOLI projector casts glowing decorative floor rangolis.",
    price: 24500,
    discountPrice: 20900,
    images: [
      "/assets/lumigo/projector-2.jpg",
      "/assets/lumigo/projector-4.jpg",
    ],
    videoUrl: "/assets/lumigo/video-demo-2.mp4",
    isFeatured: true,
    isActive: true,
    specifications: {
      projectionDistance: "2–15 metres",
      power: "100 W",
      voltage: "90–240 V, 50/60 Hz",
      lightSource: "OSRAM Warm White & RGB Accent LED",
      lightSourceLifetime: "60,000 hours",
      luminousFlux: "10,500 lm",
      ipRating: "IP65 Weatherproof",
      colorTemperature: "Warm Gold 3000K",
      weight: "3.2 kg",
    },
  },
];
